import { formatHashtag } from "../../../utils/campaignPayload";
import { getHashtagTone } from "../../../utils/opportunityCard";

export default function HashtagPill({ tag, selected = false, size = "md" }) {
    const sizeClass = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";

    return (
        <span
            className={`inline-block max-w-full truncate rounded-full font-medium ${sizeClass} ${getHashtagTone(selected)}`}
        >
            {formatHashtag(tag)}
        </span>
    );
}
